import { render, staticRenderFns } from "./SendInvoicesButton.vue?vue&type=template&id=52a24b54&"
import script from "./SendInvoicesButton.vue?vue&type=script&lang=js&"
export * from "./SendInvoicesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports